/**
 * Individual policy evaluation result for content
 */
export interface PolicyEvaluation {
  /** Unique identifier for the policy */
  policyId: string;
  /** Name of the policy for display */
  policyName: string;
  /** Whether the content is allowed (true) or rejected (false) by this policy */
  isAllowed: boolean;
  /** Optional reason for the policy decision */
  reason?: string;
  /** Confidence score for the policy decision (0-1) */
  confidence?: number;
}

/**
 * Overall policy result for a piece of content
 */
export interface PolicyResult {
  /** Overall policy status - true if all applicable policies allow the content */
  isCompliant: boolean;
  /** Number of policies that were evaluated */
  totalPoliciesEvaluated: number;
  /** Number of policies that allowed the content */
  allowedCount: number;
  /** Number of policies that rejected the content */
  rejectedCount: number;
  /** Individual policy evaluation results */
  policyEvaluations: PolicyEvaluation[];
  /** Timestamp when the policy evaluation was performed */
  evaluatedAt?: string;
}

/**
 * Policy filter options for filtering content search results
 */
export type PolicyFilterOption = 'all' | 'compliant' | 'violations';

/**
 * Policy filter labels for UI display
 */
export const POLICY_FILTER_LABELS: Record<PolicyFilterOption, string> = {
  all: 'All Content',
  compliant: 'Allowed',
  violations: 'Rejected',
};
